import { GECKO_CONSTS } from '../../../../ui';
import { v4 as uuidv4 } from 'uuid';

export const newOption = () => ({
  label: '',
  value: '',
  id: uuidv4(),
  isNew: true,
});

const findOptionById = (options, findById) =>
  options.find(({ id }) => id === findById);

const findOptionByValue = (options, findByValue) =>
  options.find(({ value }) => value === findByValue);

export const splitKeyIntoIndexAndKeyName = (key) => key.split('-');

export const isMultiSelectField = (type) =>
  type === GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI;

export const setDefaultValueForType = (defaultValue, type) => {
  const isMultiSelect = isMultiSelectField(type);
  if (
    defaultValue === undefined ||
    defaultValue === null ||
    (Array.isArray(defaultValue) && defaultValue.length === 0)
  ) {
    return isMultiSelect ? [] : null;
  }

  if (Array.isArray(defaultValue)) {
    return isMultiSelect ? defaultValue : defaultValue[0];
  }
  return isMultiSelect ? [defaultValue] : defaultValue;
};

export const convertOptionsAndDefaultsToValueMap = (
  options,
  defaultValue,
  selectFieldType
) => {
  const findOptionByIdFromBoundOptions = findOptionById.bind(null, options);
  const displayDefaultValue =
    selectFieldType === GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
      ? defaultValue.reduce((defaults, id) => {
          const option = findOptionByIdFromBoundOptions(id);
          if (!option) return defaults;
          defaults.push(option.value);
          return defaults;
        }, [])
      : findOptionByIdFromBoundOptions(defaultValue)?.value;

  return options.reduce(
    (values, { label, value }, index) => ({
      ...values,
      [`label-${index}`]: label,
      [`value-${index}`]: value,
    }),
    { default_value: displayDefaultValue }
  );
};

const formatSingleSelectIdMNapping = (defaults, optionFinder) => {
  const id = optionFinder(defaults)?.id;
  return id ? id : null;
};

const formatSingleSelectValueMapping = (defaults, optionFinder) => {
  const id = optionFinder(defaults)?.id;
  return id ? id : null;
};

export const getDefaultAsIdFromSingleEntryOptions = (
  defaults,
  options,
  type
) => {
  const findOptionByValue = (options, findByValue) =>
    options.find(({ value }) => value === findByValue).id;
  const findOptionByValueFromBoundOptions = findOptionByValue.bind(
    null,
    options
  );

  const findOption = (options, findByValue) =>
    options.find(({ value }) => value === findByValue);
  const findOneOptionByIdFromOptions = findOption.bind(null, options);

  if (isMultiSelectField(type)) {
    const things = defaults
      .map(findOptionByValueFromBoundOptions)
      .map((id) => id);
    return things;
  }

  const selection = formatSingleSelectValueMapping(
    defaults,
    findOneOptionByIdFromOptions
  );

  return selection;
};

export const getDefaultAsIdFromOptions = (defaults, options, type) => {
  const getOptionIdById = (options, findById) =>
    options.find(({ id }) => id === findById).id;
  const findOptionByIdFromBoundOptions = getOptionIdById.bind(null, options);

  const findOption = (options, findById) =>
    options.find(({ id }) => id === findById);
  const findOneOptionByIdFromOptions = findOption.bind(null, options);

  if (isMultiSelectField(type)) {
    return defaults.map(findOptionByIdFromBoundOptions).map((id) => id);
  }
  return formatSingleSelectIdMNapping(defaults, findOneOptionByIdFromOptions);
};

export const unarchiveOptionsWhereNewOptionsMatch = (options = []) =>
  options
    .filter(({ isNew }) => isNew === true)
    .reduce(
      (options, newOption) => {
        const archivedOptionIndex = options.findIndex(
          (option) =>
            isArchivedOption(option) && newOption.value === option.value
        );
        if (archivedOptionIndex === -1) return [...options];
        newOption.id = options[archivedOptionIndex].id;
        options.splice(archivedOptionIndex, 1);
        return [...options];
      },
      [...options]
    );

export const convertOptionToSaveFormat = ({ label, value, hidden, id }) => ({
  label,
  value,
  hidden,
  id,
});

export const addNewOptionIfAllAreArchived = (options = []) =>
  options.filter((option) => !isArchivedOption(option)).length === 0
    ? [...options, newOption()]
    : options;

export const isArchivedOption = ({ hidden }) => hidden === true;
export const archiveOption = (option) => {
  // No return as we deliberately want to manipulate state here
  option.hidden = true;
};
export const optionHasValue = ({ value }) => !!value;

export const optionsListIsEmpty = (options) =>
  !Array.isArray(options) ||
  options.filter((option) => !isArchivedOption(option)).length === 0;

export default {
  getDefaultAsIdFromOptions,
  getDefaultAsIdFromSingleEntryOptions,
  convertOptionsAndDefaultsToValueMap,
  newOption,
  splitKeyIntoIndexAndKeyName,
  isMultiSelectField,
  setDefaultValueForType,
  unarchiveOptionsWhereNewOptionsMatch,
  convertOptionToSaveFormat,
  addNewOptionIfAllAreArchived,
  isArchivedOption,
  optionHasValue,
  archiveOption,
  optionsListIsEmpty,
};
